var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',[_vm._t("title"),_vm._v(" "),_c('md-card-content',{staticClass:"md-layout md-alignment-center-left"},[_vm._t("default")],2),_vm._v(" "),_c('md-card-actions',[_vm._t("actions")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/FilterBar.vue